import React from 'react';
import type { DashboardData } from './DashboardShell';
import KpiCard from './KpiCard';
import CurrentPriceCard from './CurrentPriceCard';

interface KpiGridProps {
  data: DashboardData;
}

export default function KpiGrid({ data }: KpiGridProps) {
  const { currentPrice, average, minimum, maximum, minHour, maxHour } = data;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {/* Hero: Current Price — spans 2 cols on xl */}
      <div className="sm:col-span-2 xl:col-span-2 2xl:col-span-2">
        <CurrentPriceCard
          price={currentPrice}
          currentHour={data.currentHour}
        />
      </div>

      {/* Tagesdurchschnitt */}
      <KpiCard
        label="Tagesdurchschnitt"
        value={average}
        unit="€/MWh"
        sublabel="Ø heute"
        variant="neutral"
      />

      {/* Min + Max stacked on mobile, side-by-side on sm */}
      <div className="grid grid-cols-2 xl:grid-cols-1 2xl:grid-cols-1 gap-4">
        <KpiCard
          label="Tagesminimum"
          value={minimum}
          unit="€/MWh"
          sublabel={`${String(minHour).padStart(2, '0')}:00 Uhr`}
          variant={minimum < 0 ? 'negative' : 'positive'}
        />
        <KpiCard
          label="Tagesmaximum"
          value={maximum}
          unit="€/MWh"
          sublabel={`${String(maxHour).padStart(2, '0')}:00 Uhr`}
          variant={maximum > 150 ? 'danger' : maximum > 80 ? 'warning' : 'neutral'}
        />
      </div>
    </div>
  );
}